/* eslint-disable */

/**
 * The menu availability chime: one short play of plucky.mp3 per change.
 *
 * Its own element and unlock, separate from notificationSound.js, so a menu toggle never
 * waits behind (or cuts off) the new-order alert. Unlike that player there is no queue:
 * staff often switch off several items in a row and a chime per item is noise, so a play
 * that lands inside the gap of the previous one is simply dropped.
 */

const SOUND_PATH = 'sounds/plucky.mp3'
const GAP_MS = 1200

let audio = null
let unlocked = false
let lastPlayedAt = 0
const heardKeys = new Set()

function element () {
    if (!audio) {
        audio = new Audio(SOUND_PATH)
        audio.preload = 'auto'
    }
    return audio
}

/**
 * Browsers refuse to play audio until the user has interacted with the page. Prime the
 * element with a muted play/pause during a real gesture so later alerts are allowed
 * through.
 */
export function unlock () {
    if (unlocked) return Promise.resolve(true)
    const a = element()
    a.muted = true
    return a.play().then(() => {
        a.pause()
        a.currentTime = 0
        a.muted = false
        unlocked = true
        return true
    }).catch(() => {
        a.muted = false
        return false
    })
}

export function isUnlocked () {
    return unlocked
}

/**
 * Play once for this key. Repeats of a key are ignored, so a redelivered Ably message
 * can never double-chime even if it slips past the store's own dedupe.
 */
export function play (key) {
    if (!unlocked) return
    if (key !== undefined && key !== null) {
        if (heardKeys.has(key)) return
        heardKeys.add(key)
        if (heardKeys.size > 500) {
            heardKeys.delete(heardKeys.values().next().value)
        }
    }
    const now = Date.now()
    if (now - lastPlayedAt < GAP_MS) return
    lastPlayedAt = now

    const a = element()
    a.currentTime = 0
    const started = a.play()
    if (started && typeof started.catch === 'function') started.catch(() => {})
}

export function reset () {
    heardKeys.clear()
    lastPlayedAt = 0
}
